<template>
  <div>
    <!-- Other system login  loading................................ -->
  </div>
</template>

<script>
import qs from "qs";
import { Loading } from "element-ui";
import { Notification } from "element-ui";
export default {
  created() {
    //  这个遮罩层有点垃圾，后续自行重写
    let loadingService = Loading.service({
      fullscreen: true,
      lock: true,
      text: this.$t("loginPage.logining"),
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.2)",
      customClass: "loadingServiceClass",
    });
    let url = window.location.href;
    let urlStr = url.split("?")[1];
    let param = qs.parse(urlStr);
    let token = param?.token;
    if (token) {
      this.$actions.setGlobalState({
        accessToken: token,
      });
      localStorage.setItem(
        "accessToken",
        // aes.encrypt(res.data.access_token)
        token
      );
      loadingService.close();
      this.$router.push({
        name: "Home",
      });
    } else {
      let resultCode = param?.resultCode;
      if (resultCode) {
        Notification.error(this.$t("httpResponsePromptMessage." + resultCode));
      } else {
        Notification.error(this.$t("loginPromptMessage.loginError"));
      }
      loadingService.close();
      this.$router.push({ name: "Login" });
    }
  },
};
</script>

<style lang="scss" scoped>
.loadingServiceClass {
}
</style>
